import React from 'react';
import Link from '@docusaurus/Link';
import {useLocation} from '@docusaurus/router';
import {translate} from '@docusaurus/Translate';
import {useBaseUrlUtils} from '@docusaurus/useBaseUrl';

import styles from './styles.module.css';

const destinations = [
  {label: 'Começar', id: 'docsNav.start', to: '/docs/start/overview', activePaths: ['/docs/start']},
  {label: 'Pagamentos', id: 'docsNav.payments', to: '/docs/payments/charges', activePaths: ['/docs/payments']},
  {label: 'Catálogo e assinaturas', id: 'docsNav.catalog', to: '/docs/customers', activePaths: ['/docs/customers', '/docs/subscriptions']},
  {label: 'Afiliados e split', id: 'docsNav.affiliates', to: '/docs/finance/affiliates-and-payouts', activePaths: ['/docs/finance']},
  {label: 'Webhooks', id: 'docsNav.webhooks', to: '/docs/webhooks/overview', activePaths: ['/docs/webhooks']},
  {label: 'Referência da API', id: 'docsNav.reference', to: '/docs/api-reference/overview', activePaths: ['/docs/api-reference']},
  {label: 'SDKs e ferramentas', id: 'docsNav.tools', to: '/docs/tools/sdk-and-tools', activePaths: ['/docs/tools']},
  {label: 'Changelog', id: 'docsNav.changelog', to: '/docs/changelog', activePaths: ['/docs/changelog']},
];

export default function DocsSubnav(): React.ReactElement {
  const {pathname} = useLocation();
  const {withBaseUrl} = useBaseUrlUtils();

  return (
    <div className={`${styles.root} docs-subnav`}>
      <div className={styles.inner} role="navigation" aria-label={translate({id: 'docsNav.ariaLabel', message: 'Navegação da documentação'})}>
        <div className={styles.links}>
          {destinations.map((item) => {
            const active = item.activePaths.some((itemPath) => {
              const activePath = withBaseUrl(itemPath).replace(/\/$/, '');
              return pathname === activePath || pathname.startsWith(`${activePath}/`);
            });
            return (
              <Link key={item.to} className={styles.link} data-active={active} aria-current={active ? 'page' : undefined} to={item.to}>
                {translate({id: item.id, message: item.label})}
              </Link>
            );
          })}
        </div>
        <Link className={styles.version} to="/docs/api-reference/overview">v1</Link>
      </div>
    </div>
  );
}
